import { useReduxBlog } from './useReduxBlog';
import React from 'react';
import { TWO_COLUMN_MAX_WIDTH } from '@spotify-internal/frodor-modules';
import styled from 'styled-components';
import { Text, ButtonTertiary } from '@spotify-internal/encore-web';
import { HeaderImageGrid } from '../ui/HeaderImageGrid';
import { useT, useNumberFormatter } from '../../../features/src/i18n';
import { TrackVisibility } from '../../utils/Visibility/TrackVisibility';

const Title = styled(Text)`
  z-index: 2;
  grid-row: 2;
  display: flex;
  align-items: flex-end;
`;

const HeroContent = styled.div`
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    display: none;
  }
  grid-row: 3;
  grid-column: 5/13;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
`;

export const ArtistBanner = () => {
  const { hero } = useReduxBlog();
  const t = useT();
  const numberFormatter = useNumberFormatter();

  return (
    <div className="encore-inverted-dark-set">
      <HeaderImageGrid backgroundImage={hero && `url("${hero.bannerImage}")`}>
        <Title variant="headlineLarge">
          {' '}
          {t('FRODOR_278509', 'News', '')}{' '}
        </Title>
        {hero && (
          <TrackVisibility
            threshold={0.6}
            eventCategory="Frodor - blog page artist banner"
            eventLabel={hero.artistName}
          >
            <HeroContent>
              <Text variant="titleLarge">
                <ButtonTertiary
                  style={{
                    fontSize: '24px',
                    padding: '0px',
                  }}
                  semanticColor="textBase"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://open.spotify.com/artist/${hero.artistId}?utm_campaign=s4a|header|${hero.artistId}&utm_source=s4a&utm_medium=s4aheader`}
                  aria-label={t(
                    'FRODOR_893097',
                    'listen to {artistName} on Spotify',
                    '',
                    {
                      artistName: hero.artistName,
                    },
                  )}
                >
                  {hero.artistName}
                </ButtonTertiary>
              </Text>
              {hero.listeners && (
                <Text variant="bodyMediumBold">
                  {t(
                    'FRODOR_e69386',
                    '{monthlyListeners} Monthly Listeners',
                    '',
                    {
                      monthlyListeners: (numberFormatter as $TSFixMe).format(
                        hero.listeners,
                      ),
                    },
                  )}
                </Text>
              )}
            </HeroContent>
          </TrackVisibility>
        )}
      </HeaderImageGrid>
    </div>
  );
};
